__turbopack_context__.v({
  "narvarLogo": "NarvarLogo-module__Q6NTxW__narvarLogo",
});
